import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getFirestoreItem } from '../api/getFirestoreItem.ts';
import { COLLECTIONS } from '../constants';

export const useGetData = <T>(
  id?: string,
  collection?: string,
): UseQueryResult<T | null, Error> => {
  const _collection = collection || COLLECTIONS.listings;

  return useQuery<T | null, Error>({
    enabled: !!id,
    queryKey: [_collection, id],
    queryFn: () => getFirestoreItem<T>(id!, _collection),
    throwOnError: true,
  });
};
